import { Component, Vue } from 'vue-property-decorator'
import { fixedContentNoLogin } from '@/assets/js/main.js'
import OtherUrlConstants from '@/common/OtherUrlConstants'

@Component({
  name: 'CAAG1130',
  components: {}
  })
export default class CAAG1130Controller extends Vue {
  /**
   * 画面要素描画後処理
   */
  mounted() {
    fixedContentNoLogin()
    this.init()
  }

  /**
   * 初期処理
   */
  private async init() {}

  /**
   * コールセンター番号リンク押下
   */
  private callCenter(phoneNumber: string) {
    window.open('tel:' + phoneNumber, '_self')
  }

  /**
   * 移換手続き説明動画リンク押下
   */
  private gotoTransferProcedureExplanation() {
    window.open(OtherUrlConstants.TRANSFER_PROCEDURE_EXPLANATION + 'DCDLweb1130', '_blank')
  }

  /**
   * 企業型DC資格喪失時のお手続きご案内リンク押下
   */
  private gotoKojingataPortal() {
    window.open(OtherUrlConstants.INFORMATION_ON_PROCEDURES, '_blank')
  }

  /**
   * 裁定請求お手続きナビリンク押下
   */
  private gotoRcptOfOldAgeBnft() {
    window.open(OtherUrlConstants.OLD_AGE_BENEFIT_RECIPIENT, '_blank')
  }

  /**
   * 年金受取額シミュレーションリンク押下
   */
  private gotoCAHG1220() {
    this.$router.push({ name: 'cahg1220BeforLogin' })
  }

  /**
   * 資格喪失後や一般のお手続きはこちらリンク押下
   */
  private gotoDCDoor() {
    window.open(OtherUrlConstants.DC_PERSONAL_PORTAL, '_blank')
  }

  /**
   * 戻るリンク押下
   */
  private gotoCAAG1010() {
    this.$router.push({ name: 'caag1010' })
  }
}
